import { SeverityColors, deviceSeriesKeys } from '@src/utils/aiAlerts/mapping';
import { getDeviceSeriesOption } from './lineGraphOptions';
import { isEmpty } from 'lodash';

export const getUniqueDevicesForTimeSeries = (data) => {
  // unique devices count is shown from issue start time
  // and end time on the diagnostic graph in the tooltip
  const uniques = {};
  data.forEach((element) => {
    if (element.results.impactedUniques) {
      uniques[element.timestamp] =
        `<br/>Impacted Unique Devices: <b>${element.results.impactedUniques}</b>
      <br/>Cumulative Impacted Unique Devices: <b>${element.results.cumulativeImpactedUniques}</b>
      <br/>Total Unique Devices: <b>${element.results.totalUniques}</b>
      <br/>Total Cumulative Unique Devices: <b>${element.results.totalCumulativeImpactedUniques}</b>`;
    }
  });

  return uniques;
};

export const getPcpDropForTooltip = (data) => {
  const pcpDrop = {};
  data.forEach((element) => {
    if (element.results.pcpDrop) {
      pcpDrop[element.timestamp] = `<br/>PCP drop: <b>${element.results.pcpDrop}%</b>`;
    }
  });
  return pcpDrop;
};

export const getBrushLineDataBySeverity = (alertEvents) =>
  alertEvents.map((alertEvent) => ({
    type: 'time',
    xAxis: alertEvent.graphTime,
    name: alertEvent.eventType,
    label: {
      formatter: alertEvent.eventType,
      position: 'end',
      show: false,
    },
    itemStyle: { color: SeverityColors[alertEvent.eventType] },
    alertEvent,
  }));

export const getUniqueDevicesSeries = (data) => {
  const dataSet = {}; // Object.fromEntries(Object.keys(deviceLabels).map(device => ([device,[]])));
  deviceSeriesKeys.forEach((d) => (dataSet[d] = []));

  data.forEach((row) => {
    const values = row.results;
    deviceSeriesKeys.forEach((d) => {
      if (d in values) {
        dataSet[d].push([row.timestamp, values[d]]);
      }
    });
  });

  const series: any = [];
  deviceSeriesKeys.forEach((d) => {
    if (!isEmpty(dataSet[d])) {
      series.push(getDeviceSeriesOption(d, dataSet[d]));
    }
  });

  return series;
};
